<div [ngClass]="{'loading': showLoader}">
  <router-outlet />
  <div class="bottom-panel" *ngIf="!isController">
    <button *ngIf="instalPrompt?.deferredPrompt" mat-fab extended (click)="instalPrompt.promptInstall()">
      <mat-icon>download</mat-icon>
      Install
    </button>
    <button mat-fab (click)="openBottomSheet()">
      <mat-icon>apps</mat-icon>
    </button>

  </div>
</div>
<div *ngIf="showLoader" class="loading-overlay">
  <mat-progress-spinner *ngIf="showLoader" mode="indeterminate"
  diameter="50" color="primary"></mat-progress-spinner>

</div>

